import { Plus, Camera, Stethoscope, Book, type LucideIcon } from 'lucide-react';

export type TeamBStep = {
  id: string;
  path: string;
  name: string;
  shortName: string;
  desc: string;
  owner: string;
  icon: LucideIcon;
};

/** B 队四步流程,首页卡片与顶部导航共用 */
export const TEAM_B_STEPS: TeamBStep[] = [
  {
    id: 'add',
    path: '/add',
    name: '添加植物',
    shortName: '添加',
    desc: '拍照 → AI 识别种类',
    icon: Plus,
    owner: '王晟骅',
  },
  {
    id: 'daily',
    path: '/daily',
    name: '拍照记录',
    shortName: '记录',
    desc: '3 个必填 · 1 分钟',
    icon: Camera,
    owner: '王晟骅',
  },
  {
    id: 'health',
    path: '/advice',
    name: 'AI 健康诊断',
    shortName: '诊断',
    desc: '病虫害 + 1 项建议',
    icon: Stethoscope,
    owner: '易陈',
  },
  {
    id: 'diary',
    path: '/timeline',
    name: '养护日记',
    shortName: '日记',
    desc: '健康档案 + 异常事件',
    icon: Book,
    owner: '华睿',
  },
];

/** 根据 pathname 判断当前在第几步(0-based),-1 表示不在主流程(如首页/报告) */
export function teamBStepIndex(pathname: string): number {
  if (pathname === '/' || pathname === '/report') return -1;
  if (pathname === '/reminder') return 2;
  return TEAM_B_STEPS.reduce((best, s, i) => {
    if (pathname === s.path || pathname.startsWith(`${s.path}/`)) return i;
    return best;
  }, -1);
}
